import {
  faCheckCircle,
  faExclamationCircle,
  faQuestionCircle,
} from "@fortawesome/pro-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

export const SCAN_METHOD_STYLES = {
  warn: "text-[var(--color-red-800)]",
  neutral: "text-[var(--color-gray-700)]",
  ok: "text-[var(--color-green-600)]",
};

export function getScanMethodInfo({
  scanMethod,
  joinExp,
  whereExp,
}: {
  scanMethod: string;
  joinExp: string | null;
  whereExp: string | null;
}): [icon: IconProp, className: string] {
  if (
    (scanMethod === "Seq Scan" || scanMethod === "Parallel Seq Scan") &&
    (whereExp !== null || joinExp !== null) // Sequential Scans with WHERE or JOIN
  ) {
    return [faExclamationCircle, SCAN_METHOD_STYLES.warn];
  } else if (scanMethod === "Append" || scanMethod === "Merge Append") {
    return [faQuestionCircle, SCAN_METHOD_STYLES.neutral];
  } else {
    // Index Scan, Index Only Scan, Bitmap Heap Scan, Tid Scan, or Sequential Scans w/o WHERE or JOIN
    return [faCheckCircle, SCAN_METHOD_STYLES.ok];
  }
}
